var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ProjectCard"},[_c('div',{staticClass:"ProjectCard-img"},[_c('img',{attrs:{"src":_vm.imgPath,"title":_vm.imgTitle,"alt":_vm.imgAlt}})]),_c('div',{staticClass:"ProjectCard-content"},[_c('a',{attrs:{"href":`${_vm.baseUrl}/projects/${_vm.id}`}},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }